import {useGetAvsluttedePlassSaker} from "../../api/plassSaker";
import {useAvsluttedePrissoknader, usePrissoknader} from "../../api/prissoknader";
import LoadingSpinner from "../LoadingSpinner";
import React, {ReactNode} from "react";
import {sorterAvsluttedeSakerPåDato, SakInfo,} from "../../utils/sakService";
import {PktAlert, PktTable, PktTableBody, PktTableDataCell, PktTableRow} from "@oslokommune/punkt-react";
import {isLoadingStatus} from "../../utils/utils";
import {Link} from "react-router-dom";
import {OPPSIGELSE_ROUTE, PERMISJON_ROUTE} from "../../routes";

export function AvsluttedeSaker() {
    const [avsluttedePlassSaker, avsluttedePlassSakerResponseStatus] = useGetAvsluttedePlassSaker()
    const [ferdigstiltePrisSoknader, ferdigstiltePrisSoknaderResponseStatus] = usePrissoknader()
    const [avsluttedePrisSoknader, avsluttedePrisSoknaderResponseStatus] = useAvsluttedePrissoknader()
    if (isLoadingStatus(avsluttedePlassSakerResponseStatus) || isLoadingStatus(ferdigstiltePrisSoknaderResponseStatus) || isLoadingStatus(avsluttedePrisSoknaderResponseStatus)) {
        return (
            <SectionWrapper>
                <LoadingSpinner/>
            </SectionWrapper>
        )
    }

    if (avsluttedePlassSakerResponseStatus === "error" || ferdigstiltePrisSoknaderResponseStatus === "error" || avsluttedePrisSoknaderResponseStatus === "error" ||
        avsluttedePlassSaker === undefined || ferdigstiltePrisSoknader === undefined || avsluttedePrisSoknader === undefined) {
        return (
            <SectionWrapper>
                <PktAlert skin={"warning"}>
                    Det skjedde en feil ved innhenting av dine avsluttede saker.
                </PktAlert>
            </SectionWrapper>
        )
    }

    const avsluttedeSaker = sorterAvsluttedeSakerPåDato(avsluttedePlassSaker, ferdigstiltePrisSoknader, avsluttedePrisSoknader);

    return (
        <SectionWrapper>
            <PktTable responsiveView className={'mt-size-20'}>
                {avsluttedeSaker.length > 0 ? (
                    <PktTableBody>
                        {avsluttedeSaker.map((avsluttetSak) => (
                            <PktTableRow key={avsluttetSak.id}>
                                <PktTableDataCell dataLabel={'Dato'}>
                            <span
                                className={'pkt-sr-only'}>Dato, </span> {new Date(avsluttetSak.dato).toLocaleDateString('no')}
                                </PktTableDataCell>
                                <PktTableDataCell className="notranslate" dataLabel={'Sak'}>
                                    <span className="pkt-txt-16-light">{getAvsluttetSakBeskrivelse(avsluttetSak)}</span>
                                </PktTableDataCell>
                            </PktTableRow>
                        ))}
                    </PktTableBody>
                ) : (
                    <div className={'mt-size-12'}>
                        <i>Du har ingen avsluttede saker.</i>
                    </div>
                )}
            </PktTable>
        </SectionWrapper>
    )
}

const SectionWrapper = ({children}: { children: ReactNode }) => (
    <section>
        <h2 className={'pkt-txt-22 mb-size-20'}>Avsluttede saker</h2>
        {children}
    </section>
)

const getAvsluttetSakBeskrivelse = (sak: SakInfo): ReactNode => {
    switch (sak.type) {
        case 'PLASS_SØKNAD':
            return `Søknad om barnehageplass for ${sak.navn}`
        case 'PLASS_TILBUD':
            return `Tilbud om barnehageplass for ${sak.navn}`
        case 'PRIS_SOKNAD':
            return `Søknad om redusert pris`
        case 'PLASS_OPPSIGELSE':
            return (
              <Link to={`${OPPSIGELSE_ROUTE}/${sak.id}`}>
                Oppsigelse av plass for {sak.navn}
              </Link>
            )
        case 'PLASS_PERMISJONSSØKNAD':
            return (
              <Link to={`${PERMISJON_ROUTE}/${sak.id}`}>
                Søknad om permisjon for {sak.navn}
              </Link>
            )
        default:
            return ''
    }
}
